import { Injectable } from "@angular/core";
import { ActivatedRouteSnapshot, Resolve, RouterStateSnapshot } from "@angular/router";
import { DnsConfigService } from "../services/dns-config.service";
import { Observable, take } from "rxjs";

@Injectable({
    providedIn: 'root'
})
export class DnsConfigResolver implements Resolve<any> {
    constructor(private dnsConfigService: DnsConfigService) {}

    resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<any> {
        return this.dnsConfigService.handleThemes().pipe(take(1));
    }

}